import { IHeaderGroupParams } from "@ag-grid-community/core";
import React from "react";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { useBuildDataTableColumnGroupContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { DataTableHeaderRenderer } from "shared/components/table/data/internal/DataTableHeaderRenderer";
import { MaybernTableHeaderGroupExpandButton } from "shared/components/table/maybern/MaybernTableHeaderGroupExpandButton";

export const DataTableHeaderGroupComponent: React.FC<IHeaderGroupParams> = (
  props,
) => {
  const tableContext = props.context as DataTableContext;
  const columnContext = useBuildDataTableColumnGroupContext(
    tableContext,
    props.columnGroup,
  );
  if (!columnContext) {
    return null;
  }
  return (
    <DataTableHeaderRenderer
      tableContext={tableContext}
      columnContext={columnContext}
    >
      <MaybernTableHeaderGroupExpandButton {...props} />
    </DataTableHeaderRenderer>
  );
};
